export default __webpack_public_path__ + "static/media/mozilla.fd913470.png";